import * as signalR from "@microsoft/signalr";

import { EntityTickManager } from "../../infrastructure/entity-tick-manager";
import { ErrorTemplateBuilder } from "../../infrastructure/error-template-builder";
import type { entityProcessConfig } from "../entity-process/signalr-process-config";
import { entityResultWithAccessValidator } from "../helper/custom-validator";
import { Enums } from "../helper/enums";
import { invoiceEntity } from "../model/entity/invoice-entity";
import { EntityManager } from "./entity-manager";
import PrototypeInstance from "../helper/prototype-instance";

export class SignalRBillingService {
  public setBillingConnectionEvents(connection: signalR.HubConnection) {
    connection.on("invoiceEntitySync", async (message: any) => {
      try {
        await this.invoiceEntitySync(JSON.parse(message));
      } catch (e) {
        console.error(
          ErrorTemplateBuilder.getCatchText(
            "SignalRBillingService.invoiceEntitySync",
            e,
          ),
        );
      }
    });
    connection.on("invoiceEntityTickSync", () => {
      EntityTickManager.checkInvoiceTick();
    });
  }

  public async invoiceEntitySync(message: any) {
    try {
      const [result, object]: [any, entityProcessConfig | null] =
        await EntityManager.updateEntity(
          message,
          Enums.SignalRMessageType[Enums.SignalRMessageType.InvoiceEntitySync],
          "",
          message.entityId,
        );
      if (entityResultWithAccessValidator(result, object)) {
        let clientId: number | null =
          PrototypeInstance.globalProperties.$store.getters[
            "ContactModule/getClientId"
          ];
        if (
          (result[0].statusId == 3 || result[0].statusId == 5) &&
          result[0].clientId == clientId
        ) {
          result[0]["isVisited"] = false;
          result[0]["isChanged"] = true;
          await invoiceEntity.insertOrUpdate({
            data: result[0],
          });
        } else {
          await invoiceEntity.delete((x) => x.invoiceId == result[0].invoiceId);
        }
      }
    } catch (e) {
      throw new Error(
        ErrorTemplateBuilder.getCatchText(
          "SignalRBillingService.invoiceEntitySync",
          e,
        ),
      );
    }
  }
}
